import { CSS_VAR_PREFIX } from '@/constants'
import { cssVar } from '@chakra-ui/react'

export function $cssVar(name: string) {
  return cssVar(`${CSS_VAR_PREFIX}-${name}`).reference
}

export function $color(name: string) {
  return $cssVar(`colors-${name}`)
}

export function $shadow(name: string) {
  return $cssVar(`shadows-${name}`)
}

export function $size(name: string) {
  return $cssVar(`sizes-${name}`)
}

export function $fontSize(name: string) {
  return $cssVar(`fontSizes-${name}`)
}

export function $space(name: string) {
  return $cssVar(`space-${name}`)
}
